import { AnimatePresence, motion } from 'framer-motion';
import { PropsWithChildren, useId } from 'react';
import { Motion } from '../motion';
import { SmoothMountProps } from './smooth-mount-constants';

const SmoothMount: React.FC<PropsWithChildren<SmoothMountProps>> = ({
  show,
  height = true,
  fade,
  scale,
  children,
  initialAnimation,
  mode,
  onExitComplete,
  showOverflow,
  style,
  initial,
  animate,
  exit,
  ...props
}) => {
  const key = useId();

  return (
    <AnimatePresence
      initial={initialAnimation}
      mode={mode}
      onExitComplete={onExitComplete}
    >
      {show && (
        <motion.div
          key={key}
          initial={
            initial ?? {
              height: height ? 0 : 'auto',
              opacity: fade ? 0 : 1,
              ...(scale && { scale: 0 })
            }
          }
          animate={
            animate ?? {
              height: 'auto',
              opacity: 1,
              ...(scale && { scale: 1 })
            }
          }
          exit={
            exit ?? {
              height: height ? 0 : 'auto',
              opacity: fade ? 0 : 1,
              ...(scale && { scale: 0 })
            }
          }
          style={{
            overflow: showOverflow ? 'visible' : 'hidden',
            ...style
          }}
          {...props}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SmoothMount;
